/*
  Copyright 2019 Google LLC

  Use of this source code is governed by an MIT-style
  license that can be found in the LICENSE file or at
  https://opensource.org/licenses/MIT.
*/

import {messageSW} from './messageSW.mjs';
import {Workbox} from './Workbox.mjs';
import './_version.mjs';


/**
 * @module workbox-window
 */
export {
  Workbox,
  messageSW,
};
